import { useEffect } from "react"
import { CheckCircle2, Mail, CalendarCheck } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Footer } from "@/components/Footer"
import { useBooking } from "@/context/BookingContext"
import { eventPath } from "@/lib/utils"
import { firePendingPurchase } from "@/lib/ga4"
import { phCapture } from "@/lib/posthog"

export default function BookingSuccess() {
  const { state } = useBooking()
  const slug = state.event?.slug ?? undefined

  // Fires GA4 'purchase' and PostHog 'payment_confirmed' together — once per
  // bookingId. Both are skipped atomically on refresh (flag set only after both).
  useEffect(() => {
    firePendingPurchase((data) => {
      phCapture('payment_confirmed', {
        booking_id: data.bookingId,
        event_slug: data.eventSlug,
        passenger_count: data.passengerCount,
        currency: data.currency,
        value: data.value,
        payment_option: data.paymentOption,
      })
    })
  }, [])
  return (
    <div className="min-h-screen">
      <div className="flex min-h-[80vh] items-center justify-center px-4">
        <div className="flex max-w-md flex-col items-center gap-6 text-center">
          <div className="relative">
            <div className="bg-success/20 absolute inset-0 rounded-full blur-2xl" />
            <CheckCircle2 className="text-success relative size-20" />
          </div>

          <div className="flex flex-col gap-2">
            <h1 className="text-3xl font-bold text-foreground">
              Payment Confirmed
            </h1>
            <p className="text-muted-foreground">
              Your travel package has been booked successfully. We're getting
              everything ready for your trip.
            </p>
          </div>

          <div className="flex w-full flex-col gap-3">
            <div className="flex items-center gap-3 rounded-xl border border-border bg-card px-5 py-4">
              <Mail className="size-5 shrink-0 text-primary" />
              <p className="text-left text-sm text-foreground">
                A confirmation email with your booking details and itinerary has
                been sent to your inbox.
              </p>
            </div>

            <div className="flex items-center gap-3 rounded-xl border border-border bg-card px-5 py-4">
              <CalendarCheck className="size-5 shrink-0 text-primary" />
              <p className="text-left text-sm text-foreground">
                You'll receive a reminder with check-in instructions closer to
                your travel date.
              </p>
            </div>
          </div>

          <Button
            variant="outline"
            size="lg"
            className="mt-2 w-full"
            onClick={() => {
              window.location.href = eventPath(slug)
            }}
          >
            Back to Homepage
          </Button>
        </div>
      </div>
      <Footer eventSlug={slug} />
    </div>
  )
}
